import React, { Component } from 'react';
import Header from '../../Header/Header';
import PrivacyPolicy from './PrivacyPolicy';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import HomeSlidTabs from '../Home/HomeSlidTabs';
import Footer from '../../Footer/Footer';
class PrivacyPolicyPage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<>
            {process.env.REACT_APP_MODE != "development" && <Helmet>
                <title>Gulf Ticket : PrivacyPolicyPage</title>
                <meta name="description" content="Gulf Ticket PrivacyPolicyPage" />
            </Helmet>
            }
            <Header />
            <div class="container">
                <HomeSlidTabs />
                <PrivacyPolicy />
            </div>
        </>);
    }
}

function mapStateToProps(state) {
    return {};
}
const mapActionToProps = {
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(PrivacyPolicyPage))